const AUTH_DEBUG_KEY = '__auth_debug_enabled__';

class AuthDebugger {
  private enabled: boolean;

  constructor() {
    // Check if debug mode was previously enabled in this session
    this.enabled = sessionStorage.getItem(AUTH_DEBUG_KEY) === 'true';

    // Expose methods to window object for browser console access
    if (typeof window !== 'undefined') {
      (window as any).enableAuthDebug = this.enable.bind(this);
      (window as any).disableAuthDebug = this.disable.bind(this);
      (window as any).isAuthDebugEnabled = this.isEnabled.bind(this);

      // Show status on initialization if enabled
      if (this.enabled) {
        console.log(
          '%c🔍 Auth Debug Mode is ENABLED',
          'background: #4CAF50; color: white; padding: 2px 8px; border-radius: 3px;',
          '\nTo disable, run: window.disableAuthDebug()',
        );
      }
    }
  }

  enable(): void {
    this.enabled = true;
    sessionStorage.setItem(AUTH_DEBUG_KEY, 'true');
    console.log(
      '%c✅ Auth Debug Mode ENABLED',
      'background: #4CAF50; color: white; padding: 2px 8px; border-radius: 3px;',
      '\nYou will now see detailed authentication logs.\nTo disable, run: window.disableAuthDebug()',
    );
  }

  disable(): void {
    this.enabled = false;
    sessionStorage.removeItem(AUTH_DEBUG_KEY);
    console.log(
      '%c🔕 Auth Debug Mode DISABLED',
      'background: #f44336; color: white; padding: 2px 8px; border-radius: 3px;',
    );
  }

  isEnabled(): boolean {
    return this.enabled;
  }

  log(context: string, message: string, ...args: any[]): void {
    if (!this.enabled) return;

    const timestamp = new Date().toISOString().split('T')[1].split('.')[0];
    console.log(
      `%c[${timestamp}] [${context}]%c ${message}`,
      'color: #9c27b0; font-weight: bold;',
      'color: inherit;',
      ...args,
    );
  }

  warn(context: string, message: string, ...args: any[]): void {
    if (!this.enabled) return;

    const timestamp = new Date().toISOString().split('T')[1].split('.')[0];
    console.warn(
      `%c[${timestamp}] [${context}]%c ${message}`,
      'color: #ff9800; font-weight: bold;',
      'color: inherit;',
      ...args,
    );
  }

  error(context: string, message: string, ...args: any[]): void {
    if (!this.enabled) return;

    const timestamp = new Date().toISOString().split('T')[1].split('.')[0];
    console.error(
      `%c[${timestamp}] [${context}]%c ${message}`,
      'color: #f44336; font-weight: bold;',
      'color: inherit;',
      ...args,
    );
  }

  group(context: string, label: string): void {
    if (!this.enabled) return;
    console.group(`[${context}] ${label}`);
  }

  groupEnd(): void {
    if (!this.enabled) return;
    console.groupEnd();
  }
}

export const authDebug = new AuthDebugger();

export const logAuth = (context: string, message: string, ...args: any[]) => {
  authDebug.log(context, message, ...args);
};
